import { Component, ModuleWithComponentFactories } from '@angular/core';
import * as moment from 'moment';
import { Chart } from 'chart.js';
import '../assets/js/chartjs-plugin-zoom.min.js';
import * as $ from 'jquery';
import '../assets/js/chartjs-plugin-dragData.js';





@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'testCase';
  //chartTest;



  public ngOnInit() {

    $(document).ready(function () {

      $('#resetZoom').click(function () { chartTest.resetZoom(); toggleZoomMode(); });

      function toggleZoomMode() {
        var chart = chartTest;
        var zoomOptions = chart.options.plugins.zoom.zoom;
        zoomOptions.drag = !zoomOptions.drag;
        chart.update();
       }

       function toggleDragMode(){
        var chart = chartTest;
        var dragOption = chart.options;
        dragOption.dragData = !dragOption.dragData;
        chart.update();
       }

      function modifyDataSet(chart, index, value) {

        console.log(chart);
        console.log(index);
        console.log(value);

      }

      function generateLabels() {



        var chartLabels = [];
        /*         for (let x = 0; x < 0; x++) {
                  chartLabels.push(dt.setMonth(dt.getMonth() + x));
                } */
        return chartLabels;
      }

      function generateData() {
        var chartData = [];
        /*         for (let x = 0; x < 0; x++) {
                  chartData.push(Math.floor((Math.random() * 100) + 1));
                } */
        return chartData;
      }

      function addData(numData, chart, borderColor, item) {

        var currentDate = moment('2019-04-25');

        for (var i = 0; i < numData; i++) {
          chart.data.datasets[item].data.push(Math.random() * 100);
          chart.data.datasets[item].borderColor = borderColor;

          var nextMonth = moment(currentDate).add(i, 'M');

          if (item == 0) {
            chart.data.labels.push(nextMonth);
            var newwidth = $('.chartAreaWrapper2').width() + 30;
            $('.chartAreaWrapper2').width(newwidth);
          }

        }
      }

      var chartData = {
        labels: generateLabels(),
        datasets: [{
          label: "Test Data Set 1",
          data: generateData(),
          //borderColor:'#FF3961',
          fill: false
        }, {
          label: "Test Data Set 2",
          data: generateData(),
          //borderColor:'#3961FF',
          fill: false
        }, {
          label: "Test Data Set 3",
          data: generateData(),
          //borderColor:'#3961FF',
          fill: false
        }]
      };

      var chartTest: any;

      $(function () {
        var rectangleSet = false;

        var canvasTest = $('#chart-Test');
        chartTest = new Chart(canvasTest, {
          type: 'line',
          data: chartData,
          maintainAspectRatio: false,
          responsive: true,
          options: {
            tooltips: {
              enabled: true,
              titleFontSize: 0,
              titleMarginBottom: 0,
              bodyFontSize: 12
            },
            legend: {
              display: true
            },
            scales: {
              xAxes: [{
                type: 'time',
                ticks: {
                  fontSize: 12,
                  display: true
                }
              }],
              yAxes: [{
                ticks: {
                  fontSize: 12,
                  beginAtZero: true
                }
              }]
            },
            plugins: {
              zoom: {
                zoom: {
                  enabled: true,
                  drag: true,
                  mode: 'x',
                  speed: 0.05,
                  onZoom: function ({ chart }) {
                    $('.chartAreaWrapper').css("overflow-x", "hidden");
                    toggleDragMode();
                   toggleZoomMode();
                    
                  }
                }
              }
            },
            dragData: false,
            onDragEnd: (e, datasetIndex, index, value) => {
              modifyDataSet(datasetIndex, index, value)
            },
            onDrag: (e, datasetIndex, index, value) => {
              //modifyDataSet(datasetIndex, index, value)
            },
            onDragStart: (e, datasetIndex, index, value) => {
              //modifyDataSet(datasetIndex, index, value)
            },
            animation: {
              onComplete: function () {
                
                if (!rectangleSet) {
                  
                  var scale = window.devicePixelRatio;
                  var sourceCanvas = chartTest.chart.canvas;
                  var copyWidth = chartTest.scales['y-axis-0'].width - 10;
                  var copyHeight = chartTest.scales['y-axis-0'].height + chartTest.scales['y-axis-0'].top + 10;


                  var canvasAxis: any = document.getElementById("axis-Test");
                  var targetCtx = canvasAxis.getContext("2d");

                  targetCtx.scale(scale, scale);
                  targetCtx.canvas.width = copyWidth * scale;
                  targetCtx.canvas.height = copyHeight * scale;

                  targetCtx.canvas.style.width = `${copyWidth}px`;
                  targetCtx.canvas.style.height = `${copyHeight}px`;
                  targetCtx.drawImage(sourceCanvas, 0, 0, copyWidth * scale, copyHeight * scale, 0, 0, copyWidth * scale, copyHeight * scale);

                  var sourceCtx = sourceCanvas.getContext('2d');

                  // Normalize coordinate system to use css pixels.
               
                  sourceCtx.clearRect(0, 0, copyWidth * scale, copyHeight * scale);
                  rectangleSet = true;
                }
              },
              onProgress: function () {
                
                if (rectangleSet === true) {
                  
                  var copyWidth = chartTest.scales['y-axis-0'].width;
                  var copyHeight = chartTest.scales['y-axis-0'].height + chartTest.scales['y-axis-0'].top + 10;
                
                  var sourceCtx = chartTest.chart.canvas.getContext('2d');
                  sourceCtx.clearRect(0, 0, copyWidth, copyHeight);
                }
              }
            }
          }
        });
        addData(100, chartTest, '#f18805', 0);
        addData(100, chartTest, '#f0a202', 1);
        addData(100, chartTest, '#0e1428', 2);
        toggleDragMode();
      });
    });
  }

}
